import * as React from "react";
import * as Moment from 'moment';
import * as $ from 'jquery';
import ReactHtmlParser from 'react-html-parser';
import { Slug } from '@fnv-core/utils';
import { FormControlProps } from "../interfaces/FormControlProps";
import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import { FormFieldStateHelpers } from './helpers/FormFieldStateHelpers';
import { ComponentStoreHelpers } from './helpers/ComponentStoreHelpers';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { AjaxCallHelpers } from './helpers/AjaxCallHelpers';

export interface ReadonlyState {}

class ReadOnly extends React.Component<FormControlProps, ReadonlyState> {
  constructor(props : FormControlProps) {
    super(props);
    this.state = {

    };   
  }

  componentDidMount() {
    if (ComponentStoreHelpers.hasDatasource(this)) {
        ComponentStoreHelpers.setFormFieldData(this, []);
        ComponentStoreHelpers.getData(this);
    }

    if (!!this.props.formFieldDefinition.triggerDatasourceOnShow) {
      AjaxCallHelpers.getRelatedData(this as any, (parseFloat(this.props.field.value) || 0).toString());
    }
  }

  unmounted : boolean = false;
  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    let result = FormFieldStateHelpers.getFieldState(this);
    if (!result.visible) {
      return <></>;
    }
    
    if (this.props.formFieldDefinition.concatFields) {

      // render readonly form-controls for concatted fields      
      let formDefinition = this.props.formController.props.formDefinitions[this.props.formController.props.formName];
      let concatLabel = FormControlHelpers.replaceBracketFieldsWithValues(this, this.props.formFieldDefinition.label);

      return <div className={FormStylingHelpers.getFormGroupStyle(this.props) + ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + '-readonly-form-group'}>
          {!!this.props.formFieldDefinition.concatFieldShowLabel
              ? <label title={concatLabel}>{concatLabel}</label> 
              : ""}            

          <div className="input-group">                                    
            <span className="form-control-plaintext">
              {this.props.formFieldDefinition.concatFields.map((fieldName, index) => {
                let fieldDefinition;
                formDefinition.map((formFieldDefinition) => {
                  if (formFieldDefinition.name == fieldName) {
                    fieldDefinition = formFieldDefinition;
                  }
                });
                if (fieldDefinition) {
                  let doShowCharacterWhenEmpty = !!this.props.formFieldDefinition.doShowCharacterWhenEmpty;
                  if (this.props.formFieldDefinition.showCharacterWhenEmpty && index < this.props.formFieldDefinition.showCharacterWhenEmpty.length) {
                    doShowCharacterWhenEmpty = this.props.formFieldDefinition.showCharacterWhenEmpty[index];
                  }
                  return <React.Fragment key={"concatfield-" + index}>
                    <ReadOnly
                      formController={this.props.formController}
                      formFieldDefinition={{...fieldDefinition, 
                        onlyRenderValue: true,
                        characterWhenEmpty: !!doShowCharacterWhenEmpty ? "-" : "",
                        cssClass : this.props.formFieldDefinition.concatFieldClassess && index < this.props.formFieldDefinition.concatFieldClassess.length &&
                        this.props.formFieldDefinition.concatFieldClassess[index] || "",
                        postfix : (index < this.props.formFieldDefinition.concatFields.length ? 
                            this.props.formFieldDefinition.concatFieldsSeparator || " " : "")}
                      }
                      form={this.props.form}
                      field={{value : this.props.formikBag.values[fieldName]}}
                      visibilityClass={""}
                      formikBag={this.props.formikBag}
                      formConfig={this.props.formConfig}
                      defaultValue={""}
                    ></ReadOnly>         
                  </React.Fragment>;
                }
                return <></>;
              })         
            }
          </span>
        </div>
      </div>;
    }
    let label : string = FormControlHelpers.replaceBracketFieldsWithValues(this, this.props.formFieldDefinition.label);
    
    let fieldValue: string | number = this.props.field.value || "";
    let orgFieldValue = fieldValue;

    // workaround to prevent "true" or "false" being visible in forms
    // (happens with read-only checkboxes)
    if ((this.props.field.value as unknown) === true || (this.props.field.value as unknown) === "true") {
      fieldValue = "Ja";
    }

    if ((this.props.field.value as unknown) === false || (this.props.field.value as unknown) === "false" ||
        (this.props.formFieldDefinition.type === "switch" && (this.props.field.value as unknown) === "")) {
      fieldValue = "Nee";
    }

    if (this.props.field.value && this.props.field.value.label !== undefined) {
      fieldValue = this.props.field.value.label;
    }

    if (this.props.formFieldDefinition.isCalculatedField === true && 
      this.props.formFieldDefinition.expression !== undefined) {
      let services : any = {};
      services.Moment = Moment;
      fieldValue = this.props.formFieldDefinition.expression(this.props.formikBag.values, services);
    }

    if (ComponentStoreHelpers.hasDatasource(this)) {
      const orgFieldValue = fieldValue;
      fieldValue = ComponentStoreHelpers.getValueData(this, fieldValue);
      this.props.formController.setPayload( ComponentStoreHelpers.getValueDataForPayload(this, orgFieldValue));
    } else {
      if (this.props.formFieldDefinition.options) {
        if (this.props.formFieldDefinition.valueoptions.indexOf("false") >= 0) {
          if (fieldValue == "") {
            fieldValue = "false";
          }
        }

        const optionIndex = this.props.formFieldDefinition.valueoptions.indexOf(fieldValue.toString());
        if (optionIndex >= 0) {
          fieldValue = this.props.formFieldDefinition.options[optionIndex];
        }
      }
    }
    
    if (this.props.formFieldDefinition.format) {
      fieldValue = FormControlHelpers.replaceBracketFieldsWithValues(this, this.props.formFieldDefinition.format);      
    }    

    fieldValue = FormControlHelpers.convertValueToType(fieldValue, this.props.formFieldDefinition);    

    if (fieldValue == "" && !this.props.formFieldDefinition.onlyRenderValue) {
      fieldValue = "-";
    }

    if (fieldValue == "" && this.props.formFieldDefinition.characterWhenEmpty !== "") {
      fieldValue = this.props.formFieldDefinition.characterWhenEmpty;
    }
    
    label = ReactHtmlParser(label);
    
    if (typeof fieldValue === 'string') {
      fieldValue = ReactHtmlParser(FormControlHelpers.replaceTaggedEmailAddressesWithoutTags(fieldValue));
    }

    let isParsedHtmlFieldValue : boolean = false;
    let containsHtmlTags: boolean = false;
    if (Array.isArray(fieldValue as any)) {
      isParsedHtmlFieldValue = true;
      let noDataSymbolAdded = false;
      fieldValue = (fieldValue as any).map((item) => {
        if (typeof item == "string") {
          if (!noDataSymbolAdded && $.trim(item) == "") {
            noDataSymbolAdded = true;
            return "-";    
          }
        } else {
          containsHtmlTags = true;
        }
        return item;
      });
    }

    // rendered by other wrapping ReadOnly form-control which creates ReadOnly form-controls by itself (for concatting form fields)
    if (!!this.props.formFieldDefinition.onlyRenderValue) {
      const content = <>{this.props.formFieldDefinition.prefix || ""}{fieldValue !== "-" && fieldValue}{fieldValue !== "" && fieldValue !== "-" && this.props.formFieldDefinition.postfix || ""}</>;
      if (this.props.formFieldDefinition.cssClass && this.props.formFieldDefinition.cssClass !== "") {
        if (typeof orgFieldValue === 'string') {
          orgFieldValue = Slug.fromString(orgFieldValue);
        }
        return <span data-field-value={orgFieldValue} 
          data-field-name={Slug.fromString(this.props.formFieldDefinition.name)} 
          className={this.props.formFieldDefinition.cssClass}>{content}</span>;
      }
      return <>{content}</>;
    }

    // normal handling
    return <>
      <div className={FormStylingHelpers.getFormGroupStyle(this.props) + ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + '-readonly-form-group'}>
        <label title={label}>{label}</label>
        {(this.props.formFieldDefinition.explanation !== undefined && fieldValue !== "") || 
        (this.props.formFieldDefinition.explanation === undefined) ?
        <div className="input-group">
          <span className="form-control-plaintext"
            id={this.props.formFieldDefinition.name}
            ref={this.props.formFieldDefinition.name}
            data-value={containsHtmlTags ? "" : (fieldValue || "").toString()}
            title={(this.props.formFieldDefinition.noTitleHintOnLabelTag === true || isParsedHtmlFieldValue) ? "" : (fieldValue || "").toString()}        
          >{fieldValue}</span>
        </div> : null}
      </div>
      <div className={ Slug.fromString(this.props.formFieldDefinition.name) + "-input-form-group-after" + " form-group-after "}></div>
    </>;
  }
}

export { ReadOnly };